export const sceneGrid = `
    vec3 sceneGrid(vec3 rd, float time) {
        if(rd.y>0.) return mix(vec3(.1,0.,.2), vec3(1.,.5,0.), 1.-rd.y*2.);
        float t = -1./rd.y; if(t>50.||t<0.) return mix(vec3(.1,0.,.2), vec3(1.,.5,0.), 1.);
        vec3 pos=vec3(0.,1.,time*4.)+rd*t; vec2 g = fract(pos.xz*.5)-.5;
        float l = step(.45,abs(g.x)) + step(.45,abs(g.y));
        vec3 c = mix(vec3(.2,0.,.4), vec3(0.,1.,1.), l);
        return mix(c, vec3(1.,.5,0.), smoothstep(10., 50., t));
    }
`;
